import { errorHandler } from "@/services/toastHandler";

const initState = () => ({
  // Upcoming Break Expiries
  upcomingBreakExpiries: [],
  loadingUpcomingBreakExpiries: false,
  upcomingBreakExpiriesPagination: { page: 1, limit: 10, total: 0 },

  // 250k+ Deposits
  deposits250kPlus: [],
  loadingDeposits250kPlus: false,
  deposits250kPlusPagination: { page: 1, limit: 10, total: 0 },

  // User Balances at Date
  userBalancesAtDate: [],
  loadingUserBalancesAtDate: false,
  userBalancesAtDatePagination: { page: 1, limit: 10, total: 0 },

  // Unresulted Liability
  unresolvedLiability: [],
  loadingUnresolvedLiability: false,
  unresolvedLiabilityPagination: { page: 1, limit: 10, total: 0 },

  // BDM Bonus Bets
  bdmBonusBets: [],
  loadingBdmBonusBets: false,

  // Product Profitability
  productProfitability: [],
  loadingProductProfitability: false,

  // Bonus GGR by User
  bonusGgrByUser: [],
  loadingBonusGgrByUser: false,
  bonusGgrByUserPagination: { page: 1, limit: 10, total: 0 },

  // User Transaction History
  userTransactionHistory: [],
  loadingUserTransactionHistory: false,
  userTransactionHistoryPagination: { page: 1, limit: 10, total: 0 },

  // BDM Birthdays Today
  bdmBirthdaysToday: [],
  loadingBdmBirthdaysToday: false,
});

const reportingModule = {
  namespaced: true,

  state: initState(),

  getters: {
    hasUpcomingBreakExpiries: (s) => s.upcomingBreakExpiries.length > 0,
    hasDeposits250kPlus: (s) => s.deposits250kPlus.length > 0,
    hasUnresolvedLiability: (s) => s.unresolvedLiability.length > 0,
  },

  mutations: {
    SET_UPCOMING_BREAK_EXPIRIES: (s, data) => {
      s.upcomingBreakExpiries = data.data || [];
      s.upcomingBreakExpiriesPagination = data.pagination || {};
    },
    LOAD_UPCOMING_BREAK_EXPIRIES: (s, val) =>
      (s.loadingUpcomingBreakExpiries = val),

    SET_DEPOSITS_250K_PLUS: (s, data) => {
      s.deposits250kPlus = data.data || [];
      s.deposits250kPlusPagination = data.pagination || {};
    },
    LOAD_DEPOSITS_250K_PLUS: (s, val) => (s.loadingDeposits250kPlus = val),

    SET_USER_BALANCES_AT_DATE: (s, data) => {
      s.userBalancesAtDate = data.data || [];
      s.userBalancesAtDatePagination = data.pagination || {};
    },
    LOAD_USER_BALANCES_AT_DATE: (s, val) => (s.loadingUserBalancesAtDate = val),

    SET_UNRESOLVED_LIABILITY: (s, data) => {
      s.unresolvedLiability = data.data || [];
      s.unresolvedLiabilityPagination = data.pagination || {};
    },
    LOAD_UNRESOLVED_LIABILITY: (s, val) => (s.loadingUnresolvedLiability = val),

    SET_BDM_BONUS_BETS: (s, data) => (s.bdmBonusBets = data || []),
    LOAD_BDM_BONUS_BETS: (s, val) => (s.loadingBdmBonusBets = val),

    SET_PRODUCT_PROFITABILITY: (s, data) => {
      s.productProfitability = data.data || [];
    },
    LOAD_PRODUCT_PROFITABILITY: (s, val) =>
      (s.loadingProductProfitability = val),

    SET_BONUS_GGR_BY_USER: (s, data) => {
      s.bonusGgrByUser = data.data || [];
      s.bonusGgrByUserPagination = data.pagination || {};
    },
    LOAD_BONUS_GGR_BY_USER: (s, val) => (s.loadingBonusGgrByUser = val),

    SET_USER_TRANSACTION_HISTORY: (s, data) => {
      s.userTransactionHistory = data.data || [];
      s.userTransactionHistoryPagination = data.pagination || {};
    },
    LOAD_USER_TRANSACTION_HISTORY: (s, val) =>
      (s.loadingUserTransactionHistory = val),

    SET_BDM_BIRTHDAYS_TODAY: (s, data) => (s.bdmBirthdaysToday = data.data || []),
    LOAD_BDM_BIRTHDAYS_TODAY: (s, val) => (s.loadingBdmBirthdaysToday = val),
  },

  actions: {
    async getUpcomingBreakExpiries({ commit }, params) {
      commit("LOAD_UPCOMING_BREAK_EXPIRIES", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/upcoming-break-expiries",
          { params },
        );
        commit("SET_UPCOMING_BREAK_EXPIRIES", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UPCOMING_BREAK_EXPIRIES", false);
      }
    },

    async getDeposits250kPlus({ commit }, params) {
      commit("LOAD_DEPOSITS_250K_PLUS", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/250k-plus-deposits",
          { params },
        );
        console.log(res)
        commit("SET_DEPOSITS_250K_PLUS", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_DEPOSITS_250K_PLUS", false);
      }
    },

    async getUserBalancesAtDate({ commit }, params) {
      commit("LOAD_USER_BALANCES_AT_DATE", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/user-balances-at-date",
          { params },
        );
        commit("SET_USER_BALANCES_AT_DATE", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_USER_BALANCES_AT_DATE", false);
      }
    },

    async getUnresolvedLiability({ commit }, params) {
      commit("LOAD_UNRESOLVED_LIABILITY", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/unresulted-liability",
          { params },
        );
        commit("SET_UNRESOLVED_LIABILITY", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_UNRESOLVED_LIABILITY", false);
      }
    },

    async getBdmBonusBets({ commit }) {
      commit("LOAD_BDM_BONUS_BETS", true);
      try {
        const res = await this.$api.get("/v1/portal/reports/bdm-bonus-bets");
        commit("SET_BDM_BONUS_BETS", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_BDM_BONUS_BETS", false);
      }
    },

    async getProductProfitability({ commit }) {
      commit("LOAD_PRODUCT_PROFITABILITY", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/product-profitability",
        );
        commit("SET_PRODUCT_PROFITABILITY", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_PRODUCT_PROFITABILITY", false);
      }
    },

    async getBonusGgrByUser({ commit }, params) {
      commit("LOAD_BONUS_GGR_BY_USER", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/bonus-ggr-by-user",
          { params },
        );
        commit("SET_BONUS_GGR_BY_USER", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_BONUS_GGR_BY_USER", false);
      }
    },

    async getUserTransactionHistory({ commit }, params) {
      commit("LOAD_USER_TRANSACTION_HISTORY", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/user-transaction-history",
          { params },
        );
        commit("SET_USER_TRANSACTION_HISTORY", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_USER_TRANSACTION_HISTORY", false);
      }
    },

    async getBdmBirthdaysToday({ commit }) {
      commit("LOAD_BDM_BIRTHDAYS_TODAY", true);
      try {
        const res = await this.$api.get(
          "/v1/portal/reports/bdm-birthdays-today",
        );
        commit("SET_BDM_BIRTHDAYS_TODAY", res.data);
        return res.data;
      } catch (e) {
        errorHandler(e);
      } finally {
        commit("LOAD_BDM_BIRTHDAYS_TODAY", false);
      }
    },
  },
};

export default reportingModule;
